export const ChatThreadsData = [
	{
		id: 1,
		userId: 1,
		messagesId: 1,
		type: 'user',
		read: true
	},
	{
		id: 2,
		userId: 2,
		messagesId: 2,
		type: 'user',
		read: false
	},
	{
		id: 3,
		groupId: 1,
		messagesId: 16,
		type: 'group',
		read: true
	},
	{
		id: 4,
		userId: 3,
		messagesId: 4,
		type: 'user',
		read: true
	},
	{
		id: 5,
		userId: 4,
		messagesId: 5,
		type: 'user',
		read: false
	},
	{
		id: 6,
		userId: 5,
		messagesId: 6,
		type: 'user',
		read: true
	},
	{
		id: 7,
		userId: 6,
		messagesId: 7,
		type: 'user',
		read: true
	},
	{
		id: 8,
		userId: 7,
		messagesId: 8,
		type: 'user',
		read: true
	},
	{
		id: 9,
		userId: 8,
		messagesId: 9,
		type: 'user',
		read: true
	},
	{
		id: 10,
		userId: 9,
		messagesId: 10,
		type: 'user',
		read: true
	},
	{
		id: 11,
		userId: 10,
		messagesId: 11,
		type: 'user',
		read: true
	},
	{
		id: 12,
		userId: 11,
		messagesId: 12,
		type: 'user',
		read: true
	},
	{
		id: 13,
		userId: 12,
		messagesId: 13,
		type: 'user',
		read: true
	},
	{
		id: 14,
		userId: 13,
		messagesId: 14,
		type: 'user',
		read: true
	},
	{
		id: 15,
		userId: 14,
		messagesId: 15,
		type: 'user',
		read: true
	}
];

export default ChatThreadsData;
